import { useEffect } from "react";
import { gsap } from "gsap";

interface RotateXAnimationProps {
    svgElement: SVGElement;
    rotateAngle: number,
    animationSpeed: number;
  }

  const RotateXAnimation: React.FC<RotateXAnimationProps> = ({
    svgElement,
    rotateAngle = 20,
    animationSpeed = 1,
  }) => {
    useEffect(() => {
      gsap.to(svgElement, {
        rotateX: rotateAngle,
        duration: animationSpeed,
        ease: "power1.inOut",
        repeat: -1,
        yoyo: true,
      });
    }, [svgElement, rotateAngle, animationSpeed]);
  
    return null;
  };
   
export default RotateXAnimation;
